import { useEffect, useRef, useState } from 'react';
import { OrganisationsForSageLinking } from '@futrli-sdk/organisations';
import { fetchOrgsAvailableForLinking } from '../../workspaces/api';

export const useLoadOrganisationsForLinking = (workspaceId?: string, organisationId?: string) => {
  const [isLoading, setIsLoading] = useState(!!organisationId);
  const [data, setData] = useState<OrganisationsForSageLinking>();

  const request = useRef<number>();

  useEffect(() => {
    const loadData = async (wsId: string, orgId: string) => {
      const thisRequest = request.current;
      setIsLoading(true);
      setData(undefined);
      const newData = await fetchOrgsAvailableForLinking(wsId, orgId);
      if (thisRequest === request.current) {
        setData(newData);
        setIsLoading(false);
      }
    };

    if (workspaceId && organisationId) {
      request.current = Date.now();
      loadData(workspaceId, organisationId);
    }
  }, [organisationId, workspaceId]);

  return {
    isLoading,
    data
  };
};
